var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6378 24.4665C30.685 23.747 32.572 20.6934 31.8525 17.6462C31.1329 14.599 28.0794 12.712 25.0321 13.4315C21.9849 14.1511 20.0979 17.2046 20.8175 20.2519C21.537 23.2991 24.5906 25.1861 27.6378 24.4665Z",
    fill: "#6d7177"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0171 26.1328H24.983C19.3914 26.1328 14.85 30.6547 14.8306 36.2464H38.1695C38.1501 30.6547 33.6184 26.1328 28.0171 26.1328ZM30.5747 30.0907L26.2181 34.4376C26.0333 34.6321 25.7804 34.7196 25.5276 34.7196C25.2845 34.7196 25.0414 34.6321 24.8566 34.4473L22.4449 32.1329C22.0559 31.7633 22.0462 31.1507 22.4157 30.7617C22.7853 30.3727 23.4076 30.363 23.7869 30.7325L25.5081 32.3857L29.184 28.7098C29.5633 28.3306 30.1759 28.3306 30.5552 28.7098C30.9539 29.0891 30.9539 29.7115 30.5747 30.0907Z",
    fill: "#6d7177"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 1H9C4.58172 1 1 4.58172 1 9V13.1017M39.25 1H44C48.4183 1 52 4.58172 52 9V13.1017M52 37.3051V41.4068C52 45.8251 48.4183 49.4068 44 49.4068H39.25M13.75 49.4068H9C4.58172 49.4068 1 45.8251 1 41.4068V37.3051",
    stroke: "#6d7177"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerification);
export default __webpack_public_path__ + "static/media/verification.3bf5689aeb741134eea60a5be7901d74.svg";
export { ForwardRef as ReactComponent };